const ReportCategories = () => import('../../pages/wms/ReportCategories')
const Reports = () => import('../../pages/wms/Reports')
const Report = () => import('../../pages/wms/Report')
const ReportTypeDetails = () => import('../../pages/wms/ReportTypeDetails')
const OperationsReport = () => import('../../pages/wms/OperationsReport')

export default [
  {
    entityClass: 'Orderadmin\\Reports\\Entity\\Report',
    path: '/reports',
    name: 'Reports',
    icon: 'file_download',
    noChild: true,
    component: ReportCategories,
    children: [
      { entityClass: 'Orderadmin\\Accounts\\Entity\\Account', path: 'billing-diagnostics', name: 'reportParity.diagnostics', hidden: true, noChild: true, component: () => import('../../pages/wms/BillingDiagnostics.vue') },
      {
        entityClass: 'Orderadmin\\Accounts\\Entity\\Account',
        path: 'billing-report',
        name: 'reportCatalog.builtins.billing-report.title',
        icon: 'receipt_long', noChild: true,
        component: () => import('../../pages/wms/BillingReport.vue'),
      },
      {
        entityClass: 'Orderadmin\\Accounts\\Entity\\Account',
        path: 'balance-report',
        name: 'reportCatalog.builtins.balance-report.title',
        icon: 'account_balance_wallet', noChild: true,
        component: () => import('../../pages/wms/BalanceReport.vue'),
      },
      {
        entityClass: 'Orderadmin\\Reports\\Entity\\Report',
        path: 'employee-performance',
        hidden: true,
        name: 'employeePerformance.title',
        icon: 'groups',
        noChild: true,
        component: () => import('../../pages/wms/EmployeePerformance.vue'),
      },
      {
        entityClass: 'Orderadmin\\Reports\\Entity\\Report',
        path: 'operations',
        name: 'Operational report',
        icon: 'query_stats',
        noChild: true,
        component: OperationsReport
      },
      {
        entityClass: 'Orderadmin\\Reports\\Entity\\Report',
        path: 'reports',
        name: 'ReportsReports',
        component: Reports,
        options: {
          query: {
            per_page: 25,
            page: 1,
            'order-by': [
              { type: 'field', field: 'created', direction: 'desc' }
            ]
          }
        },
        noChild: true,
        children: [
          {
            entityClass: 'Orderadmin\\Reports\\Entity\\Report',
            path: 'entity/:type',
            component: Report
          }
        ]
      },
      {
        path: 'entity/:id',
        component: ReportTypeDetails
      }
    ]
  }
]
